import {
  AUTH_LEXON_PARTNER_ID,
  AUTH_LEXON_TOKEN,
  HEADER_REFRESH_TOKEN,
  LEXON_PARTNER_ID,
  LEXON_SALT
} from '@/general/config'
import { createToken } from '@/helpers/helpers'
import { lexonHttp } from '@/plugins/axios/lexonHttp'
import { Credentials } from '@/stores/auth/authTypes'
import { AxiosRequestConfig } from 'axios'
import { jwtDecode } from 'jwt-decode'

export const loginApi = (credentials: Credentials) => {
  const params = new URLSearchParams({
    email: credentials.email,
    password: credentials.password
  })

  return lexonHttp.post('v2/login', params)
}

export const selectCompanyApi = (idCompany: string, preAuthToken: string) => {
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${preAuthToken}`
    }
  }
  return lexonHttp.post('v2/company-login', { selectedCompanyId: idCompany }, config)
}

export const refreshSessionApi = (args: { accessToken: string; refreshToken: string }) => {
  const { refreshToken, accessToken } = args
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      [HEADER_REFRESH_TOKEN]: refreshToken,
      [AUTH_LEXON_PARTNER_ID]: LEXON_PARTNER_ID
    }
  }
  return lexonHttp.post('v2/refresh-session', null, config)
}

export const logoutApi = async (accessToken: string, refreshToken: string) => {
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    [HEADER_REFRESH_TOKEN]: refreshToken,
    [AUTH_LEXON_PARTNER_ID]: LEXON_PARTNER_ID
  }
  await lexonHttp.post('v2/logout', null, { headers })
}

export const dfaLoginApi = (uuid: string) => {
  return lexonHttp.post('v2/dfa-login', { uuid })
}

export const lexnetTokenApi = (idUser: number, idCompany: number) => {
  const config: AxiosRequestConfig = {
    headers: { [AUTH_LEXON_TOKEN]: createToken(LEXON_SALT) }
  }
  return lexonHttp.get(`/lexnet/token/${idUser}/${idCompany}/get`, config)
}

export const partnerTokenExchangeApi = (partnerToken: string) => {
  const payload: { [key: string]: any } = jwtDecode(partnerToken)
  const headers = {
    Authorization: `Bearer ${partnerToken}`,
    [AUTH_LEXON_PARTNER_ID]: payload.partnerId
  }
  return lexonHttp.post('v2/conecta-login', null, { headers })
}

export const userProLoginApi = (token: string) => lexonHttp.post('v2/userpro-login', new URLSearchParams({ token }))
